import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { pipViewDate, pipViewDate4, pipViewDate5 } from "../auth/Pip";
import Header from "../components/Header";
import Loader from "../components/Loader";
import Sidebar from "../components/Sidebar";
import {
  assignBoatToDock,
  getAvailableBoats,
  getDockData,
} from "../redux/actions/staffActions";
import { pageRoutes } from "../routes/PageRoutes";
import { Formik } from "formik";
import { AssignBoatSchema } from "../auth/Schema";
import DatePicker from "react-multi-date-picker";
import ErrorMessage from "../components/ErrorMessage";
import SubHeader from "../components/SubHeader";
const AssignBoat = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dockDetails = useLocation()?.state?.data || {};
  const { isLoading1, available_boats } = useSelector(
    (state) => state?.staffReducer,
  );
  console.log({ dockDetails });
  const [isToggle, setIsToggle] = useState(false);
  const [dateValue, setDateValue] = useState();
  const [setDateError, setDataError] = useState("");
  const [disabledRanges, setDisableRages] = useState([]);
  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };

  const initialState = {
    boatId: "",
  };

  useEffect(() => {
    disableDates(dockDetails?.bookedDates);
  }, []);

  const disableDates = (val) => {
    if (val?.length != 0) {
      let data = [];
      val?.map((item) =>
        data.push({
          start: new Date(new Date(item?.from).setHours(0, 0, 0, 0)),
          end: new Date(new Date(item?.to).setHours(23, 59, 59, 999)),
        }),
      );
      setDisableRages(data);
    } else {
      setDisableRages([]);
    }
  };

  const disableMultiRanges = (currentDate) => {
    const jsDate = currentDate.toDate();
    return disabledRanges.some((range) => {
      return jsDate >= range.start && jsDate <= range.end;
    });
  };

  useEffect(() => {
    dispatch(getDockData());
    dispatch(getAvailableBoats());
  }, []);

  const handleBoatAssign = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(false);
    const callback = (response) => {
      if (response.success) {
        navigate(pageRoutes?.boat_docks);
        // dispatch(getDockData());
        // dispatch(getAvailableBoats());
      }
    };
    if (dateValue) {
      resetForm();
      setDataError("");
      const data = {
        boatId: values?.boatId,
        book_from: dateValue[0],
        book_to: dateValue[dateValue?.length - 1],
        dockId: dockDetails?.id,
      };
      dispatch(assignBoatToDock({ payload: data, callback }));
    } else {
      setDataError("Please select the date");
    }
  };

  const handleSelection = (selectedDates) => {
    if (!selectedDates.length) {
      setDateValue([]);
      return;
    }
    const sortedDates = selectedDates.sort((a, b) => a - b);
    const firstDate = sortedDates[0];
    const lastDate = sortedDates[sortedDates.length - 1];
    const newSelection = [];
    let isBlocked = false;
    for (
      let current = new Date(firstDate);
      current <= lastDate && !isBlocked;
      current.setDate(current.getDate() + 1)
    ) {
      const dateObject = new Date(current);
      if (disableMultiRanges({ toDate: () => dateObject })) {
        isBlocked = true;
        break;
      }
      newSelection.push(new Date(dateObject));
    }
    setDataError("");
    if (newSelection?.length > 1) {
      const date_selected = [
        newSelection[0],
        newSelection[newSelection?.length - 1],
      ];
      setDateValue(date_selected);
    } else {
      setDateValue(newSelection);
    }
  };

  if (isLoading1) {
    return <Loader />;
  }
  return (
    <div className="ct_dashbaord_bg">
      <div className={`ct_dashbaord_main ${isToggle == false && "ct_active"}`}>
        <Sidebar  />
        <div className="ct_content_right">
          <Header onClick={onHandleClick} />
          <div className="ct_px_23 ct_mt_30 pb-5">
            <div className="py-4">
              <div className="ct_mb_30">
                <SubHeader />
              </div>
              <Formik
                initialValues={initialState}
                validationSchema={AssignBoatSchema}
                onSubmit={(values, action) => {
                  handleBoatAssign(values, action);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  resetForm,
                }) => (
                  <form>
                    <div className="ct_white_bg_1 pb-5">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label class="form-label">
                              Boat Selection{" "}
                              <span className="ct_required_star">*</span>
                            </label>
                            <select
                              className="form-control ct_input ct_transparent_input ct_pointer_curser"
                              id="boatId"
                              value={values?.boatId}
                              onBlur={handleBlur}
                              onChange={handleChange}
                            >
                              <option value="">----Select Boat----</option>
                              {available_boats &&
                                available_boats?.map((item) => (
                                  <option value={item.id}>{item.name}</option>
                                ))}
                            </select>
                            <ErrorMessage
                              className="d-block"
                              errors={errors}
                              touched={touched}
                              fieldName="boatId"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-3">
                            <label class="form-label">
                              Select Date Range{" "}
                              <span className="ct_required_star">*</span>
                            </label>
                            <div className="d-flex gap-2 ct_flex_wrap_575 position-relative">
                              <DatePicker
                              placeholder="----Select Date Range----"
                                className="form-control "
                                style={{ cursor: "pointer" }}
                                mapDays={({ date, disabled }) => {
                                  const isDisabled = disableMultiRanges(date);
                                  return {
                                    disabled: isDisabled || disabled,
                                    style: isDisabled
                                      ? {
                                          backgroundColor: "#ccc",
                                          color: "#fff",
                                        }
                                      : undefined,
                                  };
                                }}
                                value={dateValue ?? ""}
                                range={true}
                                minDate={
                                  new Date()?.toISOString()?.split("T")[0]
                                }
                                rangeHover={false}
                                numberOfMonths={2}
                                onChange={handleSelection}
                              />
                              <i className="fa-regular fa-calendar ct_date_icon_top_123"></i>
                            </div>
                            <span style={{ color: "red" }}>{setDateError}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex justify-content-end gap-3 ct_mt_40">
                      {/* <button
                        type='button'
                        onClick={() => {
                          setDateValue();
                          resetForm();
                        }}
                        class="ct_border_radius_5 ct_h_40 ct_orange_transparent_btn"
                      >
                        Cancel
                      </button> */}
                      <button
                        type="button"
                        onClick={handleSubmit}
                        class="ct_border_radius_5 ct_h_40 ct_orange_btn"
                      >
                        Assign Boat
                      </button>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignBoat;
